import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-light p-3 border-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("h5", { class: "m-0" }, "Dashboard", -1)
  ])))
}